// extracted by mini-css-extract-plugin
module.exports = {"container":"OclEditorDialogLayout_container__DFjAqoCCZWK2QuxPTZ5hI","codeEditorContainer":"OclEditorDialogLayout_codeEditorContainer__390wFgFjyj6pQe38_XIFk9"};